import { render } from "./TablaConfIdioma.vue?vue&type=template&id=82187fc8&scoped=true"
import script from "./TablaConfIdioma.vue?vue&type=script&lang=js"
export * from "./TablaConfIdioma.vue?vue&type=script&lang=js"

import "./TablaConfIdioma.vue?vue&type=style&index=0&id=82187fc8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82187fc8"]])

export default __exports__